/**
 * This is required to make `react` available as a shared module
 * for Micro Frontends.
 *
 * For more details, read:
 *
 * https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
 */
import('./index');
